module.exports = __webpack_public_path__ + "static/img/hdw9.3db3d5ac.png";